export default "/shell-load.6a5accdc6c613b7ebcfb6b2c841d3cdb.gif";